<fui-edit-fascia (clicked$)="click()" [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()"
                 [hovered]="hovered">
    <fui-fixtures>
        <fui-fixture>
            <fui-input-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                             [title]="label" [i18nParams]="labelI18NParams" [valued]="valued"></fui-input-label>
        </fui-fixture>
    </fui-fixtures>
    <fui-fixtures>
        <fui-fixture *ngIf="this.backgroundEditable && this.foregroundEditable" class="pair-view-fixture">
            <fui-color-pair-view [backgroundColor]="value?.backgroundColor"
                                 [foregroundColor]="value?.foregroundColor"
                                 (onBackgroundClick)="backgroundClicked()"
                                 (onForegroundClick)="foregroundClicked()"></fui-color-pair-view>
        </fui-fixture>
        <fui-fixture *ngIf="!disabled">
            <fui-mark-toggle [toggled]="popped">
                <fui-icon [height]="12" [icon]="'chevron-down'" [width]="12"></fui-icon>
            </fui-mark-toggle>
        </fui-fixture>
        <fui-spanning-fixture [ngClass]="{'checkered': !!value}">
            <fui-input-dom [style.background-color]="value?.backgroundColor">
                <input class="color-input"
                       #input [disabled]="disabled" (blur)="onBlur($event)" (focus)="onFocus($event)"
                       [(ngModel)]="textValue" [placeholder]="placeholder | translate" [readonly]="true"
                       [tabindex]="tabindex" type="text" [style.color]="value?.foregroundColor">
            </fui-input-dom>
        </fui-spanning-fixture>
        <fui-fixture *ngIf="showClearIcon">
            <fui-icon [height]="15" [width]="15" [icon]="'delete'"
                      [clickable]="true" (click)="clear($event)"></fui-icon>
        </fui-fixture>
        <fui-fixture *ngIf="validateable">
            <fui-validations [control]="control" [focussed]="focussed"></fui-validations>
        </fui-fixture>
    </fui-fixtures>
</fui-edit-fascia>
<fui-color-pair-pop [popped]="popped" (popped$)="pop($event)">
    <div class="side-buffer" [ngClass]="{'popped': popped, 'no-alpha': allowAlpha === 'disabled'}">
        <div class="top-buffer"></div>
        <fui-color-pair-toggle class="pair-toggle" [(backgroundSelected)]="toggleBackgroundSelected"
                               [locked]="!(backgroundEditable && foregroundEditable)"
                               [backgroundColor]="pickerColor.backgroundColor"
                               [foregroundColor]="pickerColor.foregroundColor"></fui-color-pair-toggle>
        <div *ngIf="translatedOkLabel && translatedResetLabel"
             #colorPicker
             [(colorPicker)]="pickerColorValue"
             [cpToggle]="true"
             [cpDialogDisplay]="'inline'"
             [cpCancelButton]="true"
             [cpCancelButtonText]="translatedResetLabel"
             [cpCancelButtonClass]="'color-action-button reset'"
             [cpOKButton]="true"
             [cpOKButtonText]="translatedOkLabel"
             [cpOKButtonClass]="'color-action-button ok'"
             [cpAlphaChannel]="allowAlpha"
             [cpOutputFormat]="'hex'"
             (colorPickerSelect)="colorSelected($event)">
        </div>
    </div>
</fui-color-pair-pop>
